import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { commaSeperator, getAvatar, isNativePlatform } from 'utils';
import { UiIcon } from 'ui-components';
import { mapToFilterOption } from '../filterOption';

export function ResourceList(props) {
  const { filterResources, selectedItems, filtersContext, onResourceSelect } =
    props;
  const { t } = useTranslation();
  const handleResourceSelect = (resource) => {
    onResourceSelect(resource);
  };

  const isIncludeInNativePlatforms = isNativePlatform({
    platform: filtersContext,
    shouldIncludeNativePlatforms: true,
  });

  return (
    <div className='items-list'>
      {filterResources?.map((resource) => {
        const isSelectedResource = Boolean(selectedItems[resource.id]);
        const filterOption = mapToFilterOption(filtersContext);
        return (
          <div
            className={classNames('item', isSelectedResource && 'selected')}
            key={resource.id}
            onClick={() => {
              handleResourceSelect({ id: resource.id, title: resource.title });
            }}
          >
            <div className='flex align-start'>
              <img
                className={classNames('avatar', filterOption?.avatarClass)}
                src={getAvatar(resource?.avatar, filtersContext)}
                alt=''
              />
              <div>
                <div className='resource-title'>
                  {resource.title || t('common:notDefined')}
                </div>
                <div className='flex'>
                  <UiIcon
                    icon={
                      isIncludeInNativePlatforms ? null : filterOption?.icon
                    }
                    color={filterOption?.color}
                    hover={filterOption?.color}
                    src={
                      isIncludeInNativePlatforms
                        ? `${resource.platform?.replace(
                            '_channel',
                            ''
                          )}-colored`
                        : filterOption?.iconSrc ?? null
                    }
                    width={filterOption?.iconSrc ? 16 : undefined}
                    height={filterOption?.iconSrc ? 16 : undefined}
                  />
                  <bdi className='username ellipsis'>
                    {filterOption?.usernameIcon}
                    {filterOption?.usernameField &&
                      resource[filterOption?.usernameField]}
                  </bdi>
                </div>
                {filterOption?.subTitleField && (
                  <span className='number-label'>
                    {filterOption?.subTitle} :
                    {commaSeperator(resource[filterOption?.subTitleField]) || 0}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

ResourceList.propTypes = {
  filterResources: PropTypes.array.isRequired,
  selectedItems: PropTypes.object.isRequired,
  filtersContext: PropTypes.string.isRequired,
  onResourceSelect: PropTypes.func,
};
